import { Box, Button, Table, Text } from '@factorialco/deprecated-design-system'
import { QuotePricingLineItemFragment } from 'generated/resources/graphql'

import MoneyField from 'modules/core/components/MoneyField'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

interface ProductRowProps {
  item: QuotePricingLineItemFragment
  currency: string
  isDraftStatus: boolean
  locale: string
  onUpdate: (updates: Partial<QuotePricingLineItemFragment>) => void
  onDelete: () => void
}

const ProductRow = ({
  item,
  currency,
  isDraftStatus,
  locale,
  onUpdate,
  onDelete,
}: ProductRowProps) => {
  const handleQuantityChange = (value: string) => {
    const newQuantity = Number(value)
    const currentUnitCostCents = item.unitCostCents || 0
    const currentUnitPriceCents = item.unitPriceCents || 0
    const newBaseCostCents = Math.round(newQuantity * currentUnitCostCents)
    const newBasePriceCents = Math.round(newQuantity * currentUnitPriceCents)
    onUpdate({
      quantity: newQuantity,
      baseCostCents: newBaseCostCents,
      basePriceCents: newBasePriceCents,
    })
  }

  const handleUnitCostChange = (value: string) => {
    const newUnitCostCents = Number(value) * 100
    const currentQuantity = item.quantity || 0
    const newBaseCostCents = Math.round(currentQuantity * newUnitCostCents)
    onUpdate({
      unitCostCents: newUnitCostCents,
      baseCostCents: newBaseCostCents,
    })
  }

  const handleUnitPriceChange = (value: string) => {
    const newUnitPriceCents = Number(value) * 100
    const currentQuantity = item.quantity || 0
    const newBasePriceCents = Math.round(currentQuantity * newUnitPriceCents)
    onUpdate({
      unitPriceCents: newUnitPriceCents,
      basePriceCents: newBasePriceCents,
    })
  }
  return (
    <Table.Row>
      <Table.Cell colSpan={2}>
        <Box paddingLeft="s24" width="s300">
          {isDraftStatus ? (
            <TextField
              placeholder={i18n.t('common.name')}
              value={item.description || ''}
              onChange={(value) => onUpdate({ ['description']: value })}
            />
          ) : (
            <Text size="300" color="grey1000">
              {item.description || '-'}
            </Text>
          )}
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          {isDraftStatus ? (
            <Box flexDirection="row" justifyContent="flexEnd">
              <MoneyField
                placeholder="0"
                currency={'u'} // TODO: Translate
                onChange={handleQuantityChange}
                value={(item.quantity || 0).toString()}
              />
            </Box>
          ) : (
            <Text size="300" color="grey1000">
              {item.quantity || '-'}
            </Text>
          )}
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          {isDraftStatus ? (
            <Box flexDirection="row" justifyContent="flexEnd">
              <MoneyField
                placeholder="0"
                currency={currency}
                onChange={handleUnitCostChange}
                value={((item.unitCostCents || 0) / 100).toString()}
              />
            </Box>
          ) : (
            <Text size="300" color="grey1000">
              {MoneyWithCurrency({
                optionalDecimals: true,
                amount: item.unitCostCents || 0,
                currency,
                locale,
              })}
            </Text>
          )}
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          {isDraftStatus ? (
            <Box flexDirection="row" justifyContent="flexEnd">
              <MoneyField
                placeholder="0"
                currency={currency}
                onChange={handleUnitPriceChange}
                value={((item.unitPriceCents || 0) / 100).toString()}
              />
            </Box>
          ) : (
            <Text size="300" color="grey1000">
              {MoneyWithCurrency({
                optionalDecimals: true,
                amount: item.unitPriceCents || 0,
                currency,
                locale,
              })}
            </Text>
          )}
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {`${(item.profitCents || 0) / 100}\u00A0%`}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: item.baseCostCents || 0,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: item.basePriceCents || 0,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      {isDraftStatus && (
        <Table.Cell colSpan={1} width={80}>
          <Button type="secondary" iconName="delete" onClick={onDelete} />
        </Table.Cell>
      )}
    </Table.Row>
  )
}

export default ProductRow
